// extracted by mini-css-extract-plugin
export default {"main":"CentroEstudiosSelector_main__0NU6l"};